export * from './caps-lock.directive';
